import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { Astre, Astres } from '../_enums/astre';
import { Legion, Legions } from '../_enums/legion';
import { Personnage } from '../_models/personnage';
import { CharacterSheetService } from '../_services/character-sheet.service';
import { Router } from '@angular/router';
import { TypeDeSorts } from '../_enums/typeDeSort';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-character-sheet',
  templateUrl: './character-sheet.component.html',
  styleUrls: ['./character-sheet.component.scss']
})
export class CharacterSheetComponent implements OnInit {
  personnage!: Personnage;
  characterSheetForm!: FormGroup;
  submitted: boolean = false;

  public legions = new Legions;
  public astres = new Astres;
  
  constructor(private formBuilder: FormBuilder, private characterSheetService: CharacterSheetService, private route: ActivatedRoute, private router: Router) {
   }

  ngOnInit(): void {
    var personnageId = 0;
    this.initializePersonnageForm();
    this.route.params.pipe(first()).subscribe(params => {
        personnageId = params['characterSheetId'];
      });
    
    if (personnageId != 0)
    {
      this.characterSheetService.getPersonnage(personnageId)          
      .pipe(first())
      .subscribe({
        next: (personnage) => 
        {
          this.personnage = personnage;
          this.initializePersonnageForm();
        },
        error: (e) => 
        {
          console.error(e);
          this.router.navigate(['/characterSheets']);
        }
      });
    }
    else
    {
      this.router.navigate(['/characterSheets']);
    }
  }

      // convenience getter for easy access to form fields
      get f() { return this.characterSheetForm.controls; }

  initializePersonnageForm() {
    this.characterSheetForm = this.formBuilder.group({
      nom: [this.personnage?.nom, Validators.required],
      notePublic: [this.personnage?.notePublic],
      crimsonDisponible: [this.personnage?.crimsonDisponible, Validators.required],
      achatDisponible: [this.personnage?.achatDisponible, Validators.required],
      achatSortDisponible: [this.personnage?.achatSortDisponible, Validators.required],
      nombreGnParticipe: [this.personnage?.nombreGnParticipe, Validators.required],
      legion: [this.personnage?.legion, Validators.required],
      astre1: [this.personnage?.astre1, Validators.required],
      astre2: [this.personnage?.astre2, Validators.required],
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.characterSheetForm.invalid)
    {
    // Get all Form Controls keys and loop them
      Object.keys(this.characterSheetForm.controls).forEach(key => {
      // Get errors of every form control
      var control = this.characterSheetForm.get(key);
      if(control != null)
      {
        console.log(key);
        console.log(control.errors);
      }
    });
      return;
    }    
  }

  updatePersonnage(updatedPersonnage: Personnage) : void {
    this.personnage = updatedPersonnage;
  }

  public getLegionName(legionId: number | undefined ) : string | undefined {
    if (legionId == undefined)
      return '';

    return this.legions.values.get(legionId);
  }

  public getAstreName(astreId: number | undefined ) : string | undefined {
    if (astreId  == undefined)
      return '';

    return this.astres.values.get(astreId);
  }

  public hasBoucherie(): boolean {
    return this.personnage.competences.find(c => c.competenceId == TypeDeSorts.IdCompetenceBoucherie) != null;
  }

  public hasPharmacologie(): boolean {
    return this.personnage.competences.find(c => c.competenceId == TypeDeSorts.IdCompetencePharmacologie) != null;
  }

  public hasSorcellerie(): boolean {
    return this.personnage.competences.find(c => c.competenceId == TypeDeSorts.IdCompetenceSorcellerie) != null;
  }
}
